import React, { useEffect, useState } from "react";
import api from "../lib/api";
import Vyber from "./Vyber";

/** Materiál se vydává jen na vyhrané zakázky — ostatní fáze do výběru nepatří. */
const FAZE = "OBJEDNANO,REALIZACE";

const popisTech = (t) =>
  `${t.kategorie_name || "Technologie"}${t.vyrobce ? ` · ${t.vyrobce}` : ""}`;

/**
 * Výběr zakázky a technologie. Technologie není kosmetika — ekonomika
 * technologie sčítá výdejky podle `technologie_id`, takže bez ní se materiál
 * do marže té technologie nedostane.
 */
export default function ZakazkaPicker({ pripadId, technologieId, onChange, testid = "zakazka-picker" }) {
  const [pripady, setPripady] = useState([]);
  const [tech, setTech] = useState([]);
  const [mimoFiltr, setMimoFiltr] = useState(null);

  useEffect(() => {
    api.get("/api/obchodni-pripady", { params: { limit: 200, tech_faze: FAZE } })
      .then(({ data }) => setPripady(data.items || []))
      .catch(() => setPripady([]));
  }, []);

  useEffect(() => {
    if (!pripadId) { setTech([]); setMimoFiltr(null); return; }
    api.get(`/api/obchodni-pripady/${pripadId}`)
      .then(({ data }) => {
        const p = data.pripad || {};
        // Jen vyhrané technologie — na poptávku ani ztracenou se materiál nevydává.
        setTech((p.technologie || []).filter((t) => FAZE.split(",").includes(t.faze)));
        // Rozpracovaný doklad může držet zakázku, která už mezitím vypadla
        // z filtru. Vyhodit ji ze selectu by tiše přepsalo výběr — radši ji
        // dopíšeme zpátky.
        setMimoFiltr(p.id ? p : null);
      })
      .catch(() => { setTech([]); setMimoFiltr(null); });
  }, [pripadId]);

  const seznam = mimoFiltr && !pripady.some((p) => p.id === mimoFiltr.id)
    ? [mimoFiltr, ...pripady] : pripady;

  return (
    <div className="grid gap-3 md:grid-cols-2" data-testid={testid}>
      <label className="block">
        <span className="label-up text-muted block mb-1.5">Zakázka</span>
        <Vyber className="field" value={pripadId || ""} data-testid={`${testid}-pripad`}
          onChange={(e) => onChange(e.target.value || null, null)}>
          <option value="">— vyber zakázku —</option>
          {seznam.map((p) => (
            <option key={p.id} value={p.id}>
              {p.cislo ? `${p.cislo} · ` : ""}{p.nazev}{p.client_name ? ` — ${p.client_name}` : ""}
            </option>
          ))}
        </Vyber>
        <span className="block mt-1 t-meta text-muted-2">
          Jen zakázky s technologií objednanou nebo v montáži.
        </span>
      </label>
      <label className="block">
        <span className="label-up text-muted block mb-1.5">Technologie</span>
        <Vyber className="field" value={technologieId || ""} disabled={!pripadId}
          data-testid={`${testid}-tech`}
          onChange={(e) => {
            const t = tech.find((x) => x.id === e.target.value);
            onChange(pripadId, e.target.value || null, t ? popisTech(t) : null);
          }}>
          <option value="">— celá zakázka —</option>
          {tech.map((t) => (
            <option key={t.id} value={t.id}>{popisTech(t)}</option>
          ))}
        </Vyber>
        <span className="block mt-1 t-meta text-muted-2">
          Bez technologie se materiál nezapočítá do její marže.
        </span>
      </label>
    </div>
  );
}
